import React from 'react';
import '../styles/AppCard.css';

const AppCard = ({ app }) => {
  const handleCardClick = () => {
    window.location.href = app.url;
  };

  return (
    <div className="app-card" onClick={handleCardClick}>
      <div className="card-content">
        <h2>{app.title}</h2>
        <p>{app.description}</p>
        <div className="card-button">
          Open Workspace
          <span className="arrow">→</span>
        </div>
      </div>
    </div>
  );
};

export default AppCard;